module.exports = __webpack_public_path__ + "static/img/企业信息@4x.3b9dcd3b.png";